import { document, documents } from '../../../../models/entities/common_subentities/document';
type stateType = { [key: string]: any };
function setDocuments(state: stateType, entityId: string, entityType: keyof stateType, documents: documents, field: string = 'documents') {
    const newArr = [...state[entityType]];
    const index = newArr.findIndex((item) => item.id === entityId);
    if (index !== -1) {
        newArr[index][field] = { ...documents };
    }
    return JSON.parse(JSON.stringify(newArr));
}
function addDocument(state: stateType, entityId: string, entityType: keyof stateType, document: document, field: string = 'documents') {
    const newArr = [...state[entityType]];
    const index = newArr.findIndex((item) => item.id === entityId);
    if (index !== -1) {
        let documents = [document];
        const oldDocuments = newArr[index][field]?.documents;
        if (oldDocuments && oldDocuments.length > 0) documents = [...oldDocuments, ...documents];
        newArr[index][field] = { ...newArr[index][field], documents };
    }
    return JSON.parse(JSON.stringify(newArr));
}
function editDocument(state: stateType, entityId: string, entityType: keyof stateType, document: document, field: string = 'documents') {
    const newArr = [...state[entityType]];
    const index = newArr.findIndex((item) => item.id === entityId);
    if (index !== -1) {
        const documents = newArr[index][field]?.documents.map((item: document) => {
            if (item.id === document.id) return { ...document };
            else return { ...item };
        });
        if (documents) newArr[index][field] = { ...newArr[index][field], documents };
    }
    return JSON.parse(JSON.stringify(newArr));
}
function removeDocument(state: stateType, entityId: string, entityType: keyof stateType, documentId: number, field: string = 'documents') {
    const newArr = [...state[entityType]];
    const index = newArr.findIndex((item) => item.id === entityId);
    if (index !== -1) {
        const oldDocuments = newArr[index][field]?.documents.filter((item: document) => item.id !== documentId);
        if (oldDocuments) newArr[index][field] = { ...newArr[index][field], documents: oldDocuments };
    }
    return JSON.parse(JSON.stringify(newArr));
}

export { setDocuments, addDocument, editDocument, removeDocument };
